module.exports = __webpack_public_path__ + "img/intro5.ade14bd3.jpeg";